import React from "react";
import { InfoCardProps } from "@/types/component";
import "./index.scss";

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  value,
  icon,
  iconBgColor = "#E7212B",
  className = "",
  onClick,
  disabled = false,
}) => {
  const isInteractive = Boolean(onClick) && !disabled;
  const rootClassName = [
    "info-card",
    isInteractive ? "info-card--clickable" : "",
    disabled ? "info-card--disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (!isInteractive) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      className={rootClassName}
      onClick={isInteractive ? onClick : undefined}
      onKeyDown={isInteractive ? handleKeyDown : undefined}
      role={isInteractive ? "button" : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-disabled={disabled || undefined}
    >
      <div className="info-card__header">
        <span className="info-card__title">{title}</span>
        {icon && (
          <div
            className="info-card__icon"
            style={{ backgroundColor: iconBgColor }}
          >
            {icon}
          </div>
        )}
      </div>
      <div className="info-card__value">{value}</div>
    </div>
  );
};

export default InfoCard;
